'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDuty = undefined;

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _api = require('plugins/api');

var _api2 = _interopRequireDefault(_api);

var _utils = require('@/utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dutyChain = _api2.default.dutyChain;
/*
 *@description {Function} 序列化表单数据
 *@params {any} data序列化数据
 *@params {String} origin序序列化层级key
 *@params {Boolean} isArray 是否为数组下标
 *@return {String} 序列化成功后字符串
 *@example
 * serializeParam({
 *  list: [{
 *    title: 'title'
 *  }]
 * })
 * 结果为 list[0].title=title
 */

function serializeParam(data) {
  var origin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var isArray = arguments[2];

  var keys = void 0,
      isDate = void 0;
  //过滤null
  data = data === undefined || data === null ? '' : data;
  //过滤Date对象
  isDate = Object.prototype.toString.call(data) === '[object Date]';
  if ((typeof data === 'undefined' ? 'undefined' : (0, _typeof3.default)(data)) !== 'object' || isDate) {
    if (!origin) return new Error('data must be an Object or Array');
    //Date实例需要转换
    isDate && (data = (0, _utils.timeFormat)(data, serializeParam.format));
    return origin + '=' + data + '&';
  }
  keys = (0, _keys2.default)(data);
  keys.forEach(function (key, index) {
    var obj = data[key];
    var _origin = /\.$/.test(origin) || !origin ? '' + origin : origin + '.';
    if (Array.isArray(obj)) {
      //判断是否为基础数据类型,暂不考虑数组内部数据类型不一致,如果为null，我们统一处理
      if ((0, _typeof3.default)(obj[0]) !== 'object' || obj[0] === null) {
        return serializeParam.params += origin ? '' + _origin + key + '=' + obj.toString() + '&' : key + '=' + obj.toString() + '&';
      }
      serializeParam(obj, '' + _origin + key, true);
    } else if (Object.prototype.toString.call(obj) === '[object Object]') {
      key = origin ? isArray ? origin + '[' + index + ']' : '' + _origin + key : key + '.';
      serializeParam(obj, key);
    } else {
      key = origin ? isArray ? origin + '[' + index + ']' : '' + _origin + key : key;
      serializeParam.params += serializeParam(obj, key);
    }
  });
  return serializeParam.params.slice(0, serializeParam.params.length - 1);
}
//get请求映射
var getMapping = function getMapping() {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (['get', 'delete'].indexOf(type.toLowerCase()) === -1) return 'next';
  config.params = config.data || {};
  config.params.lang = localStorage.getItem('lang');
  config.data = null;
  if (!(0, _keys2.default)(config.headers || {}).length) {
    config.headers = {};
  }
  config.headers.terminal = 'pc';
  for (var key in config.params) {
    var item = config.params[key];
    //日期类型
    var isDate = Object.prototype.toString.call(item) === '[object Date]';
    if (isDate) {
      config.params[key] = (0, _utils.timeFormat)(item, config.format || 'yyyy-MM-dd');
    }
    //判断数据类型
    if (Array.isArray(item)) {
      config.params[key] = item.toString();
    }
  }
};
//const请求映射
var postMapping = function postMapping() {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (['post', 'put'].indexOf(type.toLowerCase()) === -1) return 'next';
  config.withCredentials = true;
  if (typeof FormData !== 'undefined' && config.data instanceof FormData) return;
  config.headers = (0, _assign2.default)({
    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
    'X-XSRF-TOKEN': localStorage.getItem('token'),
    'terminal': 'pc'
  }, config.headers);
  //加上返回token
  config.data._csrf = localStorage.getItem('token');
  config.data.lang = localStorage.getItem('lang');
  serializeParam.params = '';
  serializeParam.format = config.format || 'yyyy-MM-dd';
  if (config.disabledData) return config;
  serializeParam(config.data);
  config.data = encodeURI(serializeParam.params);
};
//注册职责链
var getDuty = dutyChain(getMapping);
var postDuty = dutyChain(postMapping);
//自定义职责链
getDuty.setNext(postDuty);
exports.getDuty = getDuty;